var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.277,
    height: 19.278,
    viewBox: "0 0 19.277 19.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_FILL0_wght400_GRAD0_opsz48",
    d: "M8,25.278V12.426L17.7,6l9.579,6.426V25.278H20.229V17.647H15.018v7.631Zm1.807-1.606h3.4V16.04h8.825v7.631H25.47V13.229L17.7,8.008,9.807,13.229ZM17.639,15.826Z",
    transform: "translate(-8 -6)",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.cf22f94e5aac03bc47d7d8e1251e6fae.svg";
export { ForwardRef as ReactComponent };